import React, { useState } from 'react';
import { Buffer } from 'buffer';
import { useNavigate } from "react-router-dom";

import { GenerateCode } from '../../components/genCode.mjs';
import TopNavBar from '../../components/topNavBar.mjs';
import Snackbar from '../../components/snackbar.mjs';

import '../pages.scss';


const HomePage = () => {
	// Initialize state
	//#####################################################################################

	const [hasSetup, setHasSetup] = useState(false); // Boolean, page rendering
	const [time, setTime] = React.useState(0); // Refresh timer
	const [shouldRefresh, setShouldRefresh] = React.useState(false); // Boolean, indicate refresh
	const [alreadyRefresh, setAlreadyRefresh] = React.useState(true); // Boolean to avoid multi refresh
	const [firstClassLoad, setFirstClassLoad] = React.useState(true); // Boolean to appropriately choose refresh strategy for loading classes
	const [playbackEstimationCounter, setPlaybackEstimationCounter] = useState(0); // Counter used to determine number of playback incrementations
	const [hasIncrementedPlayback, setHasIncrementedPlayback] = React.useState(false); // Boolean, to avoid incrementing for the entire second

	const [presentations, setPresentations] = useState([]); // User's presentations
	const [projects, setProjects] = useState([]); // User's projects
	const [creditsRemaining, setCreditsRemaining] = useState(undefined); // User's credits
	const [classList, setClassList] = useState([]); // Array of class code, name, type a non-student commands
	const [enrolledList, setEnrolledList] = useState([]); // Array of class code, name a student is enrolled in
	const [staticUserMaps, setStaticUserMaps] = useState({}); // Map of maps for static class inst/user info
	const [dynamicUserMaps, setDynamicUserMaps] = useState({}); // Map of maps for dynamic class inst/user info
	const [hardwareMaps, setHardwareMaps] = useState([]); // Map of maps for hardware class machines
	const [playingQueue, setPlayingQueue] = useState([]); // Array of identifiers whose last report was Playing
	const [selectAllChecked, setSelectAllChecked] = useState(false);

	const [presentationName, setPresentationName] = useState(''); // Presentation selected
	const [showResultsDateModal, setShowResultsDateModal] = useState(false); // Boolean, show date range picker for exporting results
	const [resultsStartDate, setResultsStartDate] = useState(''); // YYYY-MM-DD, earliest response date to include in exported results
	const [resultsEndDate, setResultsEndDate] = useState(''); // YYYY-MM-DD, latest response date to include in exported results
	const [projectName, setProjectName] = useState(''); // Project selected
	const [expandedFolders, setExpandedFolders] = useState(new Set()); // "<tree>:<folder path>/" keys of folders expanded in the narration/project lists
	const [presentationSearch, setPresentationSearch] = useState(''); // User-input filter for the narration list
	const [projectSearch, setProjectSearch] = useState(''); // User-input filter for the project list
	const [multiplayerCode, setMultiplayerCode] = useState(''); // User-input multiplayer code
	const [hudMessage, setHUDMessage] = useState(''); // User-input HUD message
	const [classDisplay, setClassDisplay] = useState(''); // Code of the class to be displayed selected from classes dropdown
	const [classType, setClassType] = useState(''); // Type of the class currently selected
	const [classToEnter, setClassToEnter] = useState(''); // Class ID of enrolled class to enter
	const [showEnterBtn, setShowEnterBtn] = useState(false); // Boolean to show enter class button
	const [stuPIN, setStuPIN] = useState(''); // Student-generated PIN
	const [avatarURL, setAvatarURL] = useState(''); // User-input ReadyPlayerMe syGlass Avatar

	const keygenID = sessionStorage.getItem('keygenID');
	const userToken = sessionStorage.getItem('userToken');
	const firstName = sessionStorage.getItem('firstName');
	const lastName = sessionStorage.getItem('lastName');

	const navigate = useNavigate();

	const cloudConciergeURL = "https://syglasscloudconcierge.net";
	// const testerConciergeURL = "https://syglasscloudbackend.net";

	const getOptions = {
		method: 'GET',
		cache: 'no-store'
	}

	// User information
	//#####################################################################################

	// const updateCredits = async () => {
	// 	fetch("/getUserItem/?token=" + userToken + "&userID=" + keygenID + "&region=us-east-2", getOptions)
    //         .then(response => response.json())
	// 		.then(data => {
	// 			if (data.Item === undefined || data.Item.Credit.N <= 0) {
	// 				setCreditsRemaining(0);
	// 			} else {
	// 				setCreditsRemaining(Number.parseFloat(data.Item.Credit.N).toFixed(2));
	// 			}
	// 		})
	// 		.catch(error => console.log(error));
	// 	setTimeout(updateCredits, 1200000);
	// }

	const getPresentations = async () => {
		fetch("/presentations/?userID=" + keygenID + "&token=" + userToken, getOptions)
		.then(response => response.json())
		.then(data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			setPresentations(data);
		})
		.catch(error => console.log(error));
	}

	const getProjects = async () => {
		fetch("/projects/?userID=" + keygenID + "&token=" + userToken, getOptions)
		.then(response => response.json())
		.then(data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			setProjects(data);
		})
		.catch(error => console.log(error));
	}

	const getClassList = async () => {
		var classCodes = [];

		fetch("/getClassAssociation/?userID=" + keygenID + "&token=" + userToken, getOptions)
		.then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			if (data.Item === undefined) {
				return;
			}

			for (let i = 0; i < data.Item.Classes.L.length; i++) {
				var cls = [];
				var classCode = data.Item.Classes.L[i].S;
				cls.push(classCode);

				await fetch("/getClass/?userID=" + keygenID + "&token=" + userToken + "&classID=" + classCode, getOptions)
				.then(response => response.json())
				.then(data => {
					if (data === "Not Authorized") {
						sessionStorage.clear();
						navigate("/");
						return;
					}

					if (data.Item.ToDelete === undefined || data.Item.ToDelete.S === "") { // If the attribute doesn't exist or is empty
						cls.push(data.Item.ClassName.S);
						cls.push("Cloud");
						classCodes.push(cls);
						setClassList(classCodes);
					} else {
						console.log(data.Item.ClassName.S + " with code " + classCode + " has been marked for deletion.");
					}
				})
				.catch(error => console.log(error));
			}
		})
		.catch(error => console.log(error));

		fetch("/getHardClassAssociation/?userID=" + keygenID + "&token=" + userToken, getOptions)
		.then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}
					
			if (data.Item === undefined) {
				return;
			}
			
			for (let k = 0; k < data.Item.Classes.L.length; k++) {
				var cls = [];
				var classid = data.Item.Classes.L[k].S;
				cls.push(classid);

				await fetch("/getHardClass/?userID=" + keygenID + "&token=" + userToken + "&classID=" + classid, getOptions)
				.then(response => response.json())
				.then(data => {
					if (data === "Not Authorized") {
						sessionStorage.clear();
						navigate("/");
						return;
					}

					if (data.Item.ToDelete === undefined || data.Item.ToDelete.S === "") { // If the attribute doesn't exist or is empty
						cls.push(data.Item.ClassName.S);
						cls.push("Hardware");
						classCodes.push(cls);
						setClassList(classCodes);
					} else {
						console.log(data.Item.ClassName.S + " with code " + classid + " has been marked for deletion.");
					}
				})
				.catch(error => console.log(error));
			}
		})
		.catch(error => console.log(error));
	}

	const getEnrollmentList = async (type) => {
		var enrollmentList = enrolledList;
		fetch("/getCloudStuEnrollment/?userID=" + keygenID + "&token=" + userToken + "&type=" + type, getOptions)
		.then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			for (var i = 0; i < data.length; i++) {
				enrollmentList.push(data[i]);
			}
			setEnrolledList(enrollmentList);
		})
		.catch(error => { 
			console.log(error);
			Snackbar("wentWrong", 10000);
		});
	}

	if(!hasSetup) { // Assign user types and do setup steps
		fetch("/getUserType/?token=" + userToken + "&userID=" + keygenID, getOptions)
        .then(response => response.json())
		.then(data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			const credits = data.Credit === undefined ? 0 : data.Credit;
			if (data.Type === "Student") {
				setCreditsRemaining(0);
				getEnrollmentList("Student");
			} else if (data.Type === "Teacher") {
				setCreditsRemaining("Unlimited");
				getPresentations();
				getClassList();
				getProjects();
			} else if (data.Type === "Scientist") { // Has credit quantity
				if (credits <= 0) {
					setCreditsRemaining(0);
				} else {
					setCreditsRemaining(Number.parseFloat(credits).toFixed(2));
				}
				//updateCredits();
				getPresentations();
				getEnrollmentList("Scientist");
				getClassList();
				getProjects();
			}
			sessionStorage.setItem("userType", data.Type);
			setHasSetup(true);
		})
		.catch(error => console.log(error));
	}

	// Build front-end elements
	//#####################################################################################

	const refreshStatuses = async (users) => {
		if (users === undefined) {
			console.log("Users are undefined");
			return;
		} else if (classType !== "Cloud" && classType !== "Hardware") {
			console.log("No class type in state");
		}

		if (classType === 'Cloud') {
			await fetch("/refreshCloud/?token=" + userToken + "&userID=" + keygenID + "&users=" + JSON.stringify(users), getOptions)
            .then(response => response.json())
			.then(data => {
				if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

				var dynamicCopy = data;

				fetch("/searchSygStatus/?token=" + userToken + "&userID=" + keygenID + "&identifiers=" + JSON.stringify(Object.keys(users)), getOptions)
				.then(response => response.json())
				.then(data => {
					if (data === "Not Authorized") {
						sessionStorage.clear();
						navigate("/");
						return;
					}

					for (let i = 0; i < data.length; i++) {
						if (dynamicCopy[data[i][0]] === undefined) {
							if (firstClassLoad) {
								return;
							} else {
								// Remove extra entry
								console.log("Removing user from map: ", data[i][0]);
								delete dynamicCopy[data[i][0]];
								continue;
							}
						}
						if (data[i][2] !== "Playing" && data[i][2] !== "Stopped" && data[i][2] !== "Paused" && data[i][2] !== "Completed") {
							dynamicCopy[data[i][0]]['presState'] = "NOT STARTED";
						} else {
							if (data[i][2] === "Playing") {
								var queueCopy = playingQueue;
								queueCopy.push(data[i][0]);
								setPlayingQueue(queueCopy);
							}
							dynamicCopy[data[i][0]]['presState'] = data[i][2].toUpperCase();
							dynamicCopy[data[i][0]]['narrationName'] = data[i][5];
							dynamicCopy[data[i][0]]['narrationPlaybackPosition'] = data[i][6];
							dynamicCopy[data[i][0]]['projectOpen'] = data[i][7];
							dynamicCopy[data[i][0]]['narrationTimestamp'] = data[i][8];
							dynamicCopy[data[i][0]]['narrationDuration'] = data[i][9];
						}	
					}
					setDynamicUserMaps(dynamicCopy);
				})
				.catch(error => console.log(error));

				var loader = document.querySelector(".loader");
            	loader.classList.add("hidden");

				var blurredElems = document.getElementsByClassName("blur");
				for (let p = 0; p < blurredElems.length; p++) {
					blurredElems[p].classList.remove("blur");
				}
			})
			.catch(error => console.log(error));
		} else if (classType === 'Hardware') {
			await fetch("/searchSygStatus/?token=" + userToken + "&userID=" + keygenID + "&identifiers=" + JSON.stringify(Object.keys(users)), getOptions)
            .then(response => response.json())
			.then(data => {
				if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

				var hardwareCopy = hardwareMaps;
				for (let i = 0; i < data.length; i++) {
					if (hardwareCopy[data[i][0]] === undefined) {
						if (firstClassLoad) {
							return;
						} else {
							// Remove extra entry
							delete hardwareCopy[data[i][0]];
							continue;
						}
					}
					if (data[i][1] === null || data[i][1] === "null" || data[i][1] === undefined) {
						hardwareCopy[data[i][0]]['sygStatus'] = "INACTIVE";
						
					} else if (data[i][2] === null || data[i][2] === "null" || data[i][2] === undefined || data[i][1] === "") {
						hardwareCopy[data[i][0]]['presStatus'] = "NOT STARTED";
					} else {
						if (data[i][2] === "Playing") {
							var queueCopy = playingQueue;
							queueCopy.push(data[i][0]);
							setPlayingQueue(queueCopy);
						}
						hardwareCopy[data[i][0]]['sygStatus'] = data[i][1].toUpperCase();
						hardwareCopy[data[i][0]]['presStatus'] = data[i][2].toUpperCase();
						hardwareCopy[data[i][0]]['userID'] = data[i][3];
						hardwareCopy[data[i][0]]['userName'] = data[i][4];
						hardwareCopy[data[i][0]]['narrationName'] = data[i][5];
						hardwareCopy[data[i][0]]['narrationPlaybackPosition'] = data[i][6];
						hardwareCopy[data[i][0]]['projectOpen'] = data[i][7];
						hardwareCopy[data[i][0]]['narrationTimestamp'] = data[i][8];
						hardwareCopy[data[i][0]]['narrationDuration'] = data[i][9];
					}	
				}
				setHardwareMaps(hardwareCopy);

				var loader = document.querySelector(".loader");
            	loader.classList.add("hidden");

				var blurredElems = document.getElementsByClassName("blur");
				for (let p = 0; p < blurredElems.length; p++) {
					blurredElems[p].classList.remove("blur");
				}
			})
			.catch(error => console.log(error));
		}
	}

	// Refresh timer
	React.useEffect(() => {
		const timer = window.setInterval(() => {
			setTime(prevTime => prevTime + 1);
			setAlreadyRefresh(false);
			setHasIncrementedPlayback(false);
		}, 1000);
		
		return () => {
			window.clearInterval(timer);
		};
	}, []);

	if (time % 10 === 0 && shouldRefresh && !alreadyRefresh) {
		setAlreadyRefresh(true);
		if (classType === "Cloud") {
			refreshStatuses(dynamicUserMaps);
		} else if (classType === "Hardware") {
			refreshStatuses(hardwareMaps);
		} else {
			console.log("Class type is not recognized");
			return;
		}
	}

	if (time % 1 === 0 && !hasIncrementedPlayback) {
		if (playingQueue.length != 0) {
			if (playbackEstimationCounter <= 8) { // 9 interpolated updates over 9 seconds before the refresh after 10 seconds
				for (let i = 0; i < playingQueue.length; i++) {
					var identifier = playingQueue[i];
					var map;
					var uType;
					if (dynamicUserMaps[identifier] !== undefined) {
						map = dynamicUserMaps;
						uType = "Cloud";
					} else if (hardwareMaps[identifier] !== undefined) {
						map = hardwareMaps;
						uType = "Hardware";
					} else {
						playingQueue.splice(i, 1)
						return;
					}

					var pos = map[identifier]['narrationPlaybackPosition'];
					if (pos < map[identifier]['narrationDuration']) {
						map[identifier]['narrationPlaybackPosition'] = pos + 1.0;
						var posObj = new Date(map[identifier]['narrationPlaybackPosition'] * 1000);
						var posMinutes = posObj.getUTCMinutes().toString();
						var posSeconds = posObj.getSeconds().toString();
						var timeString = posMinutes + ':' + posSeconds.padStart(2, '0') + " / ";
						var endObj = new Date(map[identifier]['narrationDuration'] * 1000);
						var endMinutes = endObj.getUTCMinutes().toString();
						var endSeconds = endObj.getSeconds().toString();
						timeString = timeString + endMinutes + ':' + endSeconds.padStart(2, '0');
						map[identifier]['narrationTimestamp'] = timeString;
					}
					
					if (uType === "Cloud") {
						setDynamicUserMaps(map);
					} else { 
						setHardwareMaps(map);
					}
					setHasIncrementedPlayback(true);
				}
				setPlaybackEstimationCounter(playbackEstimationCounter + 1);
			} else {
				setPlayingQueue([]);
				setPlaybackEstimationCounter(0);
			}
		}
	}

	const toggleFolder = (folderKey) => {
		setExpandedFolders(prev => {
			const next = new Set(prev);
			next.has(folderKey) ? next.delete(folderKey) : next.add(folderKey);
			return next;
		});
	}

	// Group slash-separated paths into a tree, e.g. ["A/B/x", "A/y", "z"] -> folder A (folder B (x), y), z
	const buildPathTree = (paths) => {
		const root = {folders: {}, items: []};
		for (const path of paths) {
			const segments = path.split("/").filter(segment => segment.length > 0);
			let node = root;
			for (const segment of segments.slice(0, -1)) {
				node.folders[segment] ??= {folders: {}, items: []};
				node = node.folders[segment];
			}
			node.items.push({name: segments.at(-1) ?? path, path: path});
		}
		return root;
	}

	// Keep only paths whose item name or any containing folder name matches the search text, so matching a folder keeps everything inside it
	const filterPathsBySearch = (paths, searchText) => {
		const query = searchText.trim().toLowerCase();
		if (query.length === 0) {
			return paths;
		}
		return paths.filter(path => path.toLowerCase().includes(query));
	}

	// Flatten a path tree into indented rows. Folders only expand/collapse, items are the only selectable rows.
	// While searching, every folder left in the tree holds a match, so all are shown open
	const renderPathTree = (node, treeName, selectedPath, onSelect, isSearching, depth = 0, parentKey = "") => {
		const rows = [];
		const indent = (depth * 20).toString() + 'px';
		for (const folderName of Object.keys(node.folders).sort((a, b) => a.localeCompare(b))) {
			const folderKey = parentKey + folderName + "/";
			const isExpanded = isSearching || expandedFolders.has(treeName + ":" + folderKey);
			rows.push(
				<li key={"folder:" + folderKey} title={folderName} onClick={isSearching ? undefined : () => toggleFolder(treeName + ":" + folderKey)} style={{textAlign:'left', margin:'0px', paddingLeft:indent, width:'fit-content', maxWidth:'100%', boxSizing:'border-box', lineHeight:'2', fontSize:'14px', cursor:isSearching ? 'default' : 'pointer', userSelect:'none', display:'flex', alignItems:'center'}}>
					<span className="material-symbols-outlined" style={{fontSize:'18px', width:'18px', flexShrink:0}}>{isExpanded ? 'expand_more' : 'chevron_right'}</span>
					<span className="material-symbols-outlined" style={{fontSize:'18px', marginRight:'5px', flexShrink:0}}>folder</span>
					<span style={{whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{folderName}</span>
				</li>
			);
			if (isExpanded) {
				rows.push(...renderPathTree(node.folders[folderName], treeName, selectedPath, onSelect, isSearching, depth + 1, folderKey));
			}
		}
		for (const item of [...node.items].sort((a, b) => a.name.localeCompare(b.name))) {
			rows.push(
				<li key={"item:" + item.path} title={item.name} style={{textAlign:'left', margin:'0px', paddingLeft:indent, width:'fit-content', maxWidth:'100%', boxSizing:'border-box', lineHeight:'2', display:'flex', alignItems:'center'}}>
					<input style={{marginLeft:'0px', width:'15px', flexShrink:0}} type="checkbox" checked={selectedPath === item.path} onChange={() => onSelect(selectedPath === item.path ? '' : item.path)}></input>
					<label style={{textAlign:'left', fontSize:'14px', cursor:'default', userSelect:'none', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{item.name}</label>
				</li>
			);
		}
		return rows;
	}

	// Build the SYP presentation/SYG projects options and classes/enrolled dropdown to display
	var presentationOptionsRadio;
	var projectsOptionsRadio;
	var classesList;
	var enrollList;
	if (hasSetup) {
		presentationOptionsRadio = renderPathTree(buildPathTree(filterPathsBySearch(presentations, presentationSearch)), "presentations", presentationName, setPresentationName, presentationSearch.trim().length > 0);

		projectsOptionsRadio = renderPathTree(buildPathTree(filterPathsBySearch(projects, projectSearch)), "projects", projectName, setProjectName, projectSearch.trim().length > 0);

		classesList = classList.map((clsArray) => 
			<option key={clsArray[0]} value={clsArray[0]} className={clsArray[2]}>{clsArray[1]}</option>
		);

		enrollList = enrolledList.map((enrArray) => 
			<option key={enrArray[0]} value={enrArray[0]}>{enrArray[1]}</option>
		);
	}

	const getClassInfo = async (code, type) => {
		setClassType(type);

		var allCheckbox = document.getElementById("allCheckbox");
		allCheckbox.checked = false;
		handleSelectAll();

		var loader = document.querySelector(".loader");
		loader.classList.remove("hidden");

		var stuList = document.querySelector(".tableStuList");
		stuList.children[0].cells[0].classList.add("blur");

		if (code === "DEFAULT" || code.length === 0) {
			console.log("No class");
			return;
		} else {
			if (type === "Hardware") {
				setHardwareMaps({});
				var hardMaps = {};
				await fetch("/getHardClass/?userID=" + keygenID + "&token=" + userToken + "&classID=" + code, getOptions)
					.then(response => response.json())
					.then(async data => {
						if (data === "Not Authorized") {
							sessionStorage.clear();
							navigate("/");
							return;
						}

						if (data.Item === undefined) {
							console.log("No class info");
							return;
						}

						for (let i = 0; i < data.Item.Enrolled.L.length; i++) {
							var map = data.Item.Enrolled.L[i].M;
							var name = map.MachineName.S;
							if (map.MachineNickname !== undefined && map.MachineNickname.S !== undefined && map.MachineNickname.S !== "") {
								name = map.MachineNickname.S;
							}

							hardMaps[map.Address.S] = {
								'machineName': name,
								'sygStatus': '',
								'presStatus': '',
								'selected': false,
								'userID': '',
								'userName': '',
								'narrationName': '',
								'narrationPlaybackPosition': 0.0,
								'narrationDuration': 0.0,
								'projectOpen': '',
								'narrationTimestamp': ''
							};
						}

						var loader = document.getElementsByClassName("homeLoader");
            			loader[0].classList.add("hidden");

						if (firstClassLoad) {
							setHardwareMaps(hardMaps);
							refreshStatuses(hardMaps);
							setShouldRefresh(true);
							setFirstClassLoad(false);
						} else {
							setHardwareMaps(hardMaps, function () {
								// Wait for state set before refreshing
								refreshStatuses(hardMaps);
								setShouldRefresh(true);
							});
						}
					})
					.catch(error => console.log(error));
			} else if (type === "Cloud") {
				setStaticUserMaps({});
				setDynamicUserMaps({});
				var staticMaps = {};
				var dynamicMaps = {};
				await fetch("/getClass/?userID=" + keygenID + "&token=" + userToken + "&classID=" + code, getOptions)
					.then(response => response.json())
					.then(async data => {
						if (data === "Not Authorized") {
							sessionStorage.clear();
							navigate("/");
							return;
						}

						for (let i = 0; i < data.Item.Enrolled.L.length; i++) {
							var map = data.Item.Enrolled.L[i].M;

							if (map.UserEmail.S.length >= 25) {
								map.UserEmail.S = map.UserEmail.S.substring(0, 25) + "...";
							}

							staticMaps[map.UserID.S] = {
								'userName': map.UserName.S,
								'userEmail': map.UserEmail.S
							};

							dynamicMaps[map.UserID.S] = {
								'instanceID': '',
								'instanceState': '',
								'presState': '',
								'publicIP': '',
								'selected': false,
								'narrationName': '',
								'narrationPlaybackPosition': 0.0,
								'narrationDuration': 0.0,
								'projectOpen': '',
								'narrationTimestamp': ''
							};
						}

						var idKeys = Object.keys(dynamicMaps);
						await fetch("/getReservations/?userID=" + keygenID + "&token=" + userToken)
						.then(response => response.json())
						.then(data => {
							if (data === "Not Authorized") {
								sessionStorage.clear();
								navigate("/");
								return;
							}

							for (let res of data) {
								for (let instance of res["Instances"]) {
									for (let tag of instance["Tags"]) {
										if (tag.Key === "UserID" && idKeys.includes(tag.Value)) { // There is an instance reserved when logging in
											dynamicMaps[tag.Value]['instanceID'] = instance["InstanceId"];
											dynamicMaps[tag.Value]['publicIP'] = instance["PublicIpAddress"];
										}
									};
								}
							};
						})

						var loader = document.getElementsByClassName("homeLoader");
						if (loader !== undefined && loader[0] !== undefined) {
							loader[0].classList.add("hidden");	
						}
						
						setStaticUserMaps(staticMaps);
						setDynamicUserMaps(dynamicMaps);
						refreshStatuses(dynamicMaps);
						setShouldRefresh(true);
					})
					.catch(error => console.log(error));
			} else {
				Snackbar("noType", 10000);
				return;
			}
		}
	}

	const handleCheckboxChange = (event) => {
		var id = event.target.parentNode.attributes.value.value;
		const checked = event.target.checked;

		if (!checked && selectAllChecked) {
			setSelectAllChecked(false);
		}

		if (classType === "Cloud") {
			var dynamicCopy = {...dynamicUserMaps};
			dynamicCopy[id].selected = checked;
			setDynamicUserMaps(dynamicCopy);
		} else if (classType === "Hardware") {
			var hardCopy = {...hardwareMaps};
			hardCopy[id].selected = checked;
			setHardwareMaps(hardCopy);
		} else {
			Snackbar("noType", 10000);
			return;
		}
	}

	const handleSelectAll = (e) => {
		if (classTable.length === 0) { // Empty
			return;
		}

		const checked = e.target.checked;
		setSelectAllChecked(checked);
		var hardCopy = hardwareMaps;
		var dynamicCopy = dynamicUserMaps;
		if (classType === "Cloud") {
			Object.keys(dynamicCopy).map((userid) => dynamicCopy[userid].selected = checked);
		} else if (classType === "Hardware") {
			Object.keys(hardCopy).map((address) => hardCopy[address].selected = checked);
		}

		setDynamicUserMaps(dynamicCopy);
		setHardwareMaps(hardCopy);
	}

	const userType = sessionStorage.getItem("userType");

	var classTable = [];

	 // // Sort instances alphabetically TODO
				// newInstanceSelections.sort(function(a, b) {
				// 	var nameA = a["name"].toUpperCase();
				// 	var nameB = b["name"].toUpperCase();
				// 	return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;
				//   });

	if (classDisplay.length !== 0 && userType !== "Student") {
		if (classType === "Cloud" && staticUserMaps !== undefined && staticUserMaps.length !== 0 && dynamicUserMaps !== undefined && dynamicUserMaps.length !== 0) {
			classTable = Object.keys(staticUserMaps).map((userid) =>
				<tr key={userid} style={{lineHeight:'2'}} className="row">
					<td style={{textAlign:'center'}} value={userid}><input type="checkbox" key={userid} className="checkbox" checked={dynamicUserMaps[userid].selected} onChange={(e) => handleCheckboxChange(e)}></input></td>
					<td className="nameCol" value={staticUserMaps[userid]['userName']}>{staticUserMaps[userid]['userName']}</td>
					<td className="emailCol" value={staticUserMaps[userid]['userEmail']}>{staticUserMaps[userid]['userEmail']}</td>
					<td className="sygStatus"><div id={dynamicUserMaps[userid]['instanceState'] === undefined ? "INACTIVE" : dynamicUserMaps[userid]['instanceState']}><p className="statText">{(dynamicUserMaps[userid] === undefined || dynamicUserMaps[userid]['instanceState'] === undefined || dynamicUserMaps[userid]['instanceState'] === "") ? <div className="loader"></div> : dynamicUserMaps[userid]['instanceState']}</p></div></td>
					<td className="presStatus"><div id={dynamicUserMaps[userid]['presState'] === undefined ? "NOT-STARTED" : dynamicUserMaps[userid]['presState'].replaceAll(" ", "-")}><p className="statText">{(dynamicUserMaps[userid] === undefined || dynamicUserMaps[userid]['presState'] === undefined || dynamicUserMaps[userid]['presState'] === "") ? <div className="loader"></div> : dynamicUserMaps[userid]['presState']}</p></div></td>
					<td className="narrationInfoCol">
						{dynamicUserMaps[userid]['narrationName'] !== undefined ? dynamicUserMaps[userid]['narrationName'] : ""} 
						<div className="progressBarDiv">
							<div className="progressBar" style={(dynamicUserMaps[userid]['narrationPlaybackPosition'] === undefined || dynamicUserMaps[userid]['narrationPlaybackPosition'] === null || dynamicUserMaps[userid]['narrationDuration'] === undefined) ? {width:'0px'} : {width: (100 * (dynamicUserMaps[userid]['narrationPlaybackPosition'] / dynamicUserMaps[userid]['narrationDuration'])).toString() + 'px'}}></div>
						</div> 
						{dynamicUserMaps[userid]['narrationTimestamp'] !== undefined ? dynamicUserMaps[userid]['narrationTimestamp'] : ""}
					</td>
					<td className="projectCol">{dynamicUserMaps[userid]['projectOpen']}</td>
				</tr>
			);
		} else if (classType === "Hardware") {
			classTable = Object.keys(hardwareMaps).map((address) => 
				<tr key={address} className="row">
					<td style={{textAlign:'center'}} value={address}><input type="checkbox" key={address} className="checkbox" checked={hardwareMaps[address].selected} onChange={(e) => handleCheckboxChange(e)}></input></td>
					<td className="nameCol" value={hardwareMaps[address]['machineName']} id={address}>{hardwareMaps[address]['machineName']} <div className="editIconDiv" onClick={(e) => handleEditName(e)}><i className="editIcon"><span className="editIcon" class="material-symbols-outlined">edit</span></i></div></td>
					<td className="sygStatus"><div id={hardwareMaps[address]['sygStatus']}><p className="statText">{(hardwareMaps[address] === undefined || hardwareMaps[address]['sygStatus'] === undefined || hardwareMaps[address]['sygStatus'] === "") ? <div className="loader"></div> : hardwareMaps[address]['sygStatus']}</p></div></td>
					<td className="presStatus"><div id={hardwareMaps[address]['presStatus'].replaceAll(" ", "-")}><p className="statText">{(hardwareMaps[address] === undefined || hardwareMaps[address]['presStatus'] === undefined || hardwareMaps[address]['presStatus'] === "") ? <div className="loader"></div> : hardwareMaps[address]['presStatus']}</p></div></td>
					<td className="narrationInfoCol">
						{hardwareMaps[address]['narrationName'] !== undefined ? hardwareMaps[address]['narrationName'] : ""} 
						<div className="progressBarDiv">
							<div className="progressBar" style={(hardwareMaps[address]['narrationPlaybackPosition'] === undefined || hardwareMaps[address]['narrationPlaybackPosition'] === null || hardwareMaps[address]['narrationDuration'] === undefined) ? {width:'0px'} : {width: (100 * Math.min(1.0, (hardwareMaps[address]['narrationPlaybackPosition'] / hardwareMaps[address]['narrationDuration']))).toString() + 'px', borderRadius:'5px'}}></div>
						</div> 
						{hardwareMaps[address]['narrationTimestamp'] !== undefined ? hardwareMaps[address]['narrationTimestamp'] : ""}
					</td>
					<td className="projectCol">{hardwareMaps[address]['projectOpen']}</td>
					<td className="userName" value={hardwareMaps[address]['userName']} id={hardwareMaps[address]['userName']}>{(hardwareMaps[address]['userName'] === null || hardwareMaps[address]['userName'] === undefined) ? "" : hardwareMaps[address]['userName']}</td>
				</tr>
			);
		} else {
			return;
		}
	}

	const handleCreditsDisplay = () => {
		if (userType === "Scientist") {
			if (creditsRemaining === "Unlimited") {
				return "creditDisplayUnlimited";
			} else {
				return (creditsRemaining > 15 ? "creditDisplayBodyGood" : (creditsRemaining > 5 ? "creditDisplayBodyMid" : "creditDisplayBodyExpire"));
			}
		}
	}

	// User commands
	//#####################################################################################

	const SendCommand = async (command) => {
		if (userType === "Student" || command === undefined || command.length <= 0) {
			return;
		}

		if (classType === "Hardware") {
			var nonReadyMacFlag = false;
			var selFlag = false;
			var addresses = Object.keys(hardwareMaps);
			for (let k = 0; k < addresses.length; k++) {
				if (hardwareMaps[addresses[k]].selected) {
					selFlag = true;
					if (hardwareMaps[addresses[k]]['sygStatus'] === "READY" || hardwareMaps[addresses[k]]['sygStatus'] === "CONNECTED") {
						fetch("/cacheCommand/?userID=" + keygenID + "&token=" + userToken + "&identifier=" + addresses[k] + "&command=" + command.toString(), getOptions)
						.then(response => {
							if (response.json() === "Not Authorized") {
								sessionStorage.clear();
								navigate("/");
								return;
							}

							if (response.status === 200) {
								Snackbar("cmdSent", 5000);
							}
							if (response.status === 403) {
								Snackbar("dupeCmdLimit", 10000);
							}
						})
						.catch(error => {
							console.log(error);
							Snackbar("wentWrongCommand", 10000);
						});
					} else {
						nonReadyMacFlag = true;
					}
				}
			}

			if (nonReadyMacFlag) {
				Snackbar("instancesNotReady", 10000);
				return;
			}
			if (!selFlag) {
				Snackbar("noSelectMac", 10000);
			}
		} else if (classType === "Cloud") {
			var nonReadyInstFlag = false;
			var selFlag = false;
			var ids = Object.keys(dynamicUserMaps);
			for (let i = 0; i < ids.length; i++) {
				if (dynamicUserMaps[ids[i]].selected) {
					selFlag = true;
					if (dynamicUserMaps[ids[i]]['instanceState'] === "READY" || dynamicUserMaps[ids[i]]['instanceState'] === "CONNECTED") {
						fetch("/cacheCommand/?userID=" + keygenID + "&token=" + userToken + "&identifier=" + ids[i] + "&command=" + command.toString(), getOptions)
						.then(response => {
							if (response.json() === "Not Authorized") {
								sessionStorage.clear();
								navigate("/");
								return;
							}

							if (response.status === 200) {
								Snackbar("cmdSent", 5000);
							}
							if (response.status === 403) {
								Snackbar("dupeCmdLimit", 10000);
							}
						})
						.catch(error => {
							console.log(error);
							Snackbar("wentWrongCommand", 10000);
						});
					} else {
						nonReadyInstFlag = true;
					}
				}
			}

			if (nonReadyInstFlag) {
				Snackbar("instancesNotReady", 10000);
				return;
			}
			if (!selFlag) {
				Snackbar("noSelectStu", 10000);
			}
		} else {
			Snackbar("noClassSelected", 10000);
			return;
		}
	}

	const shootConfetti = async () => {
		if (classType.length === 0) {
			Snackbar("noClassSelected", 10000);
			return;
		}

		const command = "-t 3";
		SendCommand(command.toString());
	}

	const startPresentation = async () => {
		if (classType.length === 0) {
			Snackbar("noClassSelected", 10000);
			return;
		}

		if (presentationName.length === 0) {
			Snackbar("noSelectPres", 7000);
			return;
		}

		const command = "-p " + presentationName.split("/").at(-1);
		SendCommand(command.toString());
	}

	const stopPresentation = async () => {
		if (classType.length === 0) {
			Snackbar("noClassSelected", 10000);
			return;
		}

		const command = "-p%20%20";
		SendCommand(command.toString());
	}

	const openResultsDateModal = () => {
		if (classDisplay.length === 0) {
			Snackbar("noClassSelected", 10000);
			return;
		}

		if (presentationName.length === 0) {
			Snackbar("noSelectPres", 7000);
			return;
		}

		setShowResultsDateModal(true);
	}

	const exportPresentationResults = async () => {
		if (resultsStartDate && resultsEndDate && resultsStartDate > resultsEndDate) {
			Snackbar("resultsInvalidRange", 7000);
			return;
		}

		setShowResultsDateModal(false);

		await fetch(`/generatePresentationResults?userID=${keygenID}&token=${userToken}&classID=${classDisplay}&presentationName=${presentationName.split("/").at(-1)}&startDate=${resultsStartDate}&endDate=${resultsEndDate}`)
			.then(response => response.json())
			.then(data => {
				if (!data?.success) {
					if (data.message === "No results found") {
						Snackbar("resultsFailedNone", 5000);
						return;
					}
					Snackbar("resultsFailed", 5000);
					return;
				}

				// Download the zip by creating an anchor element and adding the click event
				const blob = new Blob([new Uint8Array(data.data)], {type: data.type});
				const downloadLink = document.createElement('a');
				downloadLink.href = URL.createObjectURL(blob);
				downloadLink.download = presentationName.split("/").at(-1) + `.${data.extension}`;

				document.body.appendChild(downloadLink);
				downloadLink.click();

				setTimeout(() => {
					URL.revokeObjectURL(downloadLink.href);
					document.body.removeChild(downloadLink);
				}, 100);

				Snackbar("resultsSucceeded", 7000);
			})
			.catch(error => {
				console.log(error);
				Snackbar("resultsFailed", 10000);
			});
	}

	const launchProject = async () => {
		if (classType.length === 0) {
			Snackbar("noClassSelected", 10000);
			return;
		}

		if (projectName.length === 0) {
			Snackbar("noSelectProj", 7000);
			return;
		}

		const command = "-l " + projectName.split("/").at(-1).toString();
		SendCommand(command.toString());
	}

	const joinMultiplayer = async () => {
		if (classType.length === 0) {
			Snackbar("noClassSelected", 10000);
			return;
		}

		if (multiplayerCode.length === 0) {
			Snackbar("noMultCode", 7000);
			return;
		}

		var regex = new RegExp(/^[a-zA-Z0-9]+$/g);
		if (!regex.test(multiplayerCode)) {
			Snackbar("alphaChars", 10000);
			return;
		}

		const command = "-m " + multiplayerCode.toString();
		SendCommand(command.toString());
	}

	const leaveMultiplayer = async () => {
		if (classType.length === 0) {
			Snackbar("noClassSelected", 10000);
			return;
		}

		const command = "-m%20%20";
		SendCommand(command.toString());
	}

	const writeHUDMessage = async () => {
		if (classType.length === 0) {
			Snackbar("noClassSelected", 10000);
			return;
		}

		var msg = encodeURIComponent(hudMessage);
		const command = "-w " + msg.toString();
		SendCommand(command.toString());
	}

	const handleDisplayHUDMessage = () => {
		var textarea = document.getElementById("hudMessageTextarea");
		if (textarea.value.length === 0) {
			Snackbar("msgEmpty", 10000);
			return;
		}

		var regex = new RegExp(/^[a-zA-Z0-9!\-_()\'\":\.\?;#, ]+$/g)
		if (!regex.test(hudMessage)) {
            Snackbar("msgSupportedChars", 10000);
            return;
		}

		textarea.value = '';
		writeHUDMessage();
	}

	const handleGenPIN = async (e) => {
		e.preventDefault();

		var pinDiv = document.getElementById("studentPin");
		if (pinDiv !== undefined && pinDiv !== null) {
			pinDiv.classList.add("hidden");
		}

		var stuPIN = GenerateCode(4, 9);
		var timeMil = Date.now();

		await fetch("/cachePIN/?userID=" + keygenID + "&token=" + userToken + "&PIN=" + stuPIN + "&time=" + timeMil)
			.then(response => response.json())
			.then(data => {
				if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

				data = data.cacheRes;
				if (data !== stuPIN.toString()) {
					if (data === undefined) {
						handleGenPIN(e);
					} else {
						// Send request with an old PIN param
						fetch(cloudConciergeURL + "/serverApp/acceptPin/?pin=" + stuPIN + "&name=" + firstName + "%20" + lastName + "&token=" + userToken + "&id=" + keygenID + "&replace=" + data + "&class=" + classToEnter)
						.then(response => response.json())
						.then(data => {
							if (data === "Not Authorized") {
								sessionStorage.clear();
								navigate("/");
								return;
							}

							setStuPIN(stuPIN);
							if (pinDiv !== undefined && pinDiv !== null) {
								pinDiv.classList.remove("hidden");
							}
						})
						.catch(error => {
							console.log(error);
							Snackbar("wentWrongPINSend", 10000);
						});
					}
				} else {
					// Send regular request
					fetch(cloudConciergeURL + "/serverApp/acceptPin/?pin=" + stuPIN + "&name=" + firstName + "%20" + lastName + "&token=" + userToken + "&id=" + keygenID + "&class=" + classToEnter)
					.then(response => response.json())
					.then(data => {
						if (data === "Not Authorized") {
							sessionStorage.clear();
							navigate("/");
							return;
						}

						setStuPIN(stuPIN);
						if (pinDiv !== undefined && pinDiv !== null) {
							pinDiv.classList.remove("hidden");
						}
					})
					.catch(error => {
						console.log(error);
						Snackbar("wentWrongPINSend", 10000);
					});
				}
			})
			.catch(error => {
				console.log(error);
				Snackbar("wentWrongPIN", 10000);
			});
	}

	const startSelectedInstances = async () => {
		fetch("/startOpts/?userID=" + keygenID + "&token=" + userToken, getOptions)
		.then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			let url = "https://syglasscloudconcierge.net/serverApp/requestCloudXRServer/?";
		
			var someSelected = false; // Flag to determine if any instances have been selected
			var dynamicMapKeys = Object.keys(dynamicUserMaps);
			for (let i = 0; i < dynamicMapKeys.length; i++) {
				if (dynamicUserMaps[dynamicMapKeys[i]].selected && (dynamicUserMaps[dynamicMapKeys[i]]['instanceState'] === 'INACTIVE' || dynamicUserMaps[dynamicMapKeys[i]]['instanceState'] === '')) {
					someSelected = true;
					url = url + "user_id[]=" + dynamicMapKeys[i];

					if (i !== (dynamicMapKeys.length - 1)) {
						url = url + "&"
					}
				}
			}

			if (someSelected) {
				url = url + "&admin_id=" + keygenID;
				Snackbar("starting", 10000);
				
				const concData = await fetch(url, data)
				.then(response => response.json())
				.then(data => {
					if (data === "Not Authorized") {
						sessionStorage.clear();
						navigate("/");
						return;
					}
				});

				var dynamicCopy = dynamicUserMaps;
				var concDataKeys = Object.keys(concData); // UserIDs

				for (let j = 0; j < concDataKeys.length; j++) {
					dynamicCopy[concDataKeys[j]]['publicIP'] = concData[concDataKeys[j]];
				}

				setDynamicUserMaps(dynamicCopy);
			} else {
				Snackbar("noSelectStu", 5000);
				return;
			}
		})
		.catch(error => console.log(error));
	}

	const handleStart = () => {
		if (creditsRemaining > 0 || creditsRemaining === "Unlimited") {
			startSelectedInstances();
		} else {
			alert("Could not start servers due to insufficient credits. Contact us at info@syglass.io to purchase credits.");
		}
	}

	const handleReboot = () => {
		if (classType.length === 0 || classType === "Hardware") {
			return;
		}

		var alerted = false;
	
		if (window.confirm("Are you sure you want to reboot all of the selected servers? Any users currently in VR will be kicked out."))
		{
			fetch("/startOpts/?userID=" + keygenID + "&token=" + userToken)
			.then(response => response.json())
			.then(data => {
				if (data === "Not Authorized") {
					sessionStorage.clear();
					navigate("/");
					return;
				}

				var ids = Object.keys(staticUserMaps);
				for (let i = 0; i < ids.length; i++) {
					var userid = ids[i];
					if (dynamicUserMaps[userid].selected) {
						fetch(cloudConciergeURL + "/serverApp/rebootServer/" + dynamicUserMaps[userid]['publicIP'] + "/" , data) 
						.then(response => response.json())
						.then(data => {
							if (data === "Not Authorized") {
								sessionStorage.clear();
								navigate("/");
								return;
							}

							if (data === "Rebooting") {
								if (!alerted) {
									Snackbar("rebooting", 10000);
									alerted = true;
								}
							}
						})
						.catch(error => console.log(error));
					}
				}
				
			})
			.catch(error => console.log(error));
		}
	}

	const handleRemoveUserFromClass = async (e) => {
		var removeConfirmMessage = "Are you sure you want to remove all selected students from this class?";
		if (classType === "Hardware") {
			removeConfirmMessage = "Are you sure you want to remove all selected machines from this class?";
		}

		if (!window.confirm(removeConfirmMessage)) {
            return;
		}

		if (classType === 'Cloud') {
			var ids = Object.keys(dynamicUserMaps);
			for (let i = 0; i < ids.length; i++) {
				if (dynamicUserMaps[ids[i]].selected && (ids[i] !== keygenID)) {
					var playingQueueCopy = playingQueue;
					var uIndex = playingQueueCopy.indexOf(ids[i]);
					if (uIndex > -1) {
						playingQueueCopy.splice(uIndex, 1);
						setPlayingQueue(playingQueueCopy);
					}

					fetch("/removeUser/?userID=" + keygenID + "&token=" + userToken + "&classID=" + classDisplay + "&idRemove=" + ids[i])
					.then(data => {
						if (data === "Not Authorized") {
							sessionStorage.clear();
							navigate("/");
							return;
						}

						if (data.status === 200) {
							Snackbar("removeStu", 10000);
							getClassInfo(classDisplay, "Cloud");
						} else {
							Snackbar("wentWrong", 10000);
						}
					})
					.catch(error => console.log(error));
				}
			}
		} else if (classType === 'Hardware') {
			var addrs = Object.keys(hardwareMaps);
			for (let i = 0; i < addrs.length; i++) {
				if (hardwareMaps[addrs[i]].selected) {
					var playingQueueCopy = playingQueue;
					var mIndex = playingQueueCopy.indexOf(addrs[i]);
					if (mIndex > -1) {
						playingQueueCopy.splice(mIndex, 1);
						setPlayingQueue(playingQueueCopy);
					}

					await fetch("/removeMachineFromClass/?userID=" + keygenID + "&token=" + userToken, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({ address: addrs[i], name: hardwareMaps[addrs[i]]['machineName'], classID: classDisplay, region: 'us-east-2' }),
					})
					.then(response => response.json())
					.then(async data => {
						if (data === "Not Authorized") {
							sessionStorage.clear();
							navigate("/");
							return;
						}

						if (data.success === true) {
							Snackbar("removeStu", 10000);
							getClassInfo(classDisplay, "Hardware");
						} else {
							Snackbar("wentWrong", 10000);
							console.log(data.message);
						}
					})
					.catch(error => console.log(error));
				}
			}
		}
	}

	const handleEditName = (e) => {
		var mNameCell = e.target.parentElement.parentElement.parentElement;
		if (mNameCell === undefined) {
			return;
		}

		var id = mNameCell.id;
		var name = mNameCell.lastChild.data;

		// Preserve existing cell
		var nameCell = document.getElementById(id);

		// Create the input field
		var newCell = document.createElement("td");
		var editInput = document.createElement("input");
		editInput.classList.add("renameInput");
		newCell.appendChild(editInput);

		// Swap cells to allow editing
		nameCell.replaceWith(newCell);
		editInput.focus();

		var regex = new RegExp(/^[a-zA-Z0-9\-_()\s]+$/g);

		// Listen for "Enter" key press
		newCell.addEventListener("keyup", function(event) {
			event.preventDefault();
			if (event.keyCode === 13) {
				if (editInput.value === undefined || !regex.test(editInput.value.trim()) || editInput.value === "" || editInput.value === " ") {
					Snackbar("prohibitedChars", 10000);
					editInput.blur();
					return;
				} else if (editInput.value.length > 15) {
					Snackbar("lengthCap", 10000);
					editInput.blur();
					return;
				}

				handleUpdateMachineNickname(id, name, editInput.value)
				// Put new name in the name cell
				nameCell.lastChild.data = editInput.value;
				try {
					newCell.replaceWith(nameCell);
				} catch (error) {
					console.log(error);
				}
			}
		});

		// Listen for unfocus event
		editInput.addEventListener("blur", function(event) { // Edit canceled
			event.preventDefault();
			// Swap back
			newCell.replaceWith(nameCell);
		});
	}

	const handleUpdateMachineNickname = async (address, name, nickname) => {
		// Fetch hardware classes
		await fetch("/getHardClass/?userID=" + keygenID + "&token=" + userToken + "&classID=" + classDisplay, getOptions)
		.then(response => response.json())
		.then(async data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			if (data.Item === undefined) {
				return;
			}

			for (let i = 0; i < data.Item.Enrolled.L.length; i++) {
				if (data.Item.Enrolled.L[i].M.Address.S === address) {
					name = data.Item.Enrolled.L[i].M.MachineName.S;
				}
			}
		})
		.catch(error => console.log(error));

		await fetch("/updateMachineNickname", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ userID: keygenID, token: userToken, classID: classDisplay, address: address, name: name, nickname: nickname }),
        })
        .then(response => response.json())
		.then(data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			if (data.success) {
				Snackbar("renameSuccess", 10000);
			} else {
				if (data.message === "Unsupported characters") {
					Snackbar("prohibitedChars", 10000);
					return;
				} else {
                    Snackbar("wentWrong", 10000);
					console.log(data.message);
                    return;
                }
			}
		})
        .catch(error => {
            console.log(error);
            Snackbar("wentWrong", 10000);
        });

		getClassInfo(classDisplay, "Hardware");
	}

	const uploadSlide = async (input) => {
		if (userType === "Student") {
			return;
		}
		if (classType.length === 0) {
			Snackbar("noClassSelected", 10000);
			return;
		}

		if (input !== undefined && input.files !== null && input.files.length !== 0 && input.files[0] !== undefined) {
			var fr = new FileReader();
			fr.onload = function() { 
				fetch("/uploadSlide", {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify({ userID: keygenID, token: userToken, imageName: input.files[0].name, image: fr.result.substring(fr.result.indexOf(",") + 1), adminID: keygenID }),
				})
				.then(response => {
					if (response.status === 413) {
						Snackbar("imgTooLarge", 10000);
						return Promise.reject(response);
					}
					return response.json();
				})
				.then(data => {
					if (data === "Not Authorized") {
						sessionStorage.clear();
						navigate("/");
						return;
					}

					if (data !== undefined && data.length > 0) {
						SendCommand(data);
					} else {
						Snackbar("wentWrong", 10000);
					}
				})
				.catch(error => console.log(error));
			}

			fr.readAsDataURL(input.files[0]);
		} else {
			Snackbar("fileUploadWrong", 10000);
		}
	}

	const uploadAvatar = async () => {
		await fetch("/uploadAvatar/", {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ userID: keygenID, token: userToken, url: avatarURL.toString(), fName: firstName, lName: lastName }),
		})
		.then(response => response.json())
		.then(data => {
			if (data === "Not Authorized") {
				sessionStorage.clear();
				navigate("/");
				return;
			}

			if (data.httpStatusCode !== undefined && data.httpStatusCode === 200) {
				var avatarInput = document.getElementById("avatarInput");
                avatarInput.value = '';
				Snackbar("cmdSent", 10000);
			}  else {
				Snackbar("wentWrongAvatar", 10000);
			}
		})
		.catch(error => console.log(error));
	}

	return (
		<>
		<div>
			<TopNavBar></TopNavBar>
		</div>
		{showResultsDateModal &&
			<>
			<div className="overlay" onClick={() => setShowResultsDateModal(false)}></div>
			<section className="modal">
				<div className="resultsDateModal">
					<div className="helpModalHeader" style={{width:'442px', height:'44px', borderTopLeftRadius:'8px', borderTopRightRadius:'8px'}}>
						<p style={{fontSize:'16px', textAlign:'left', paddingLeft:'15px', marginTop:'0px', paddingTop:'10px'}}>Export narration results</p>
					</div>
					<div style={{padding:'0px 15px'}}>
						<p style={{fontSize:'14px', textAlign:'left'}}>Choose the date range of responses to include. Leave a date blank to include all responses on that side of the range.</p>
						<div style={{display:'flex', justifyContent:'space-between'}}>
							<label style={{fontSize:'14px', textAlign:'left', display:'flex', flexDirection:'column'}}>
								Start date
								<input type="date" value={resultsStartDate} max={resultsEndDate || undefined} onChange={(e) => setResultsStartDate(e.target.value)} style={{marginTop:'5px'}}></input>
							</label>
							<label style={{fontSize:'14px', textAlign:'left', display:'flex', flexDirection:'column'}}>
								End date
								<input type="date" value={resultsEndDate} min={resultsStartDate || undefined} onChange={(e) => setResultsEndDate(e.target.value)} style={{marginTop:'5px'}}></input>
							</label>
						</div>
						<div style={{display:'flex', justifyContent:'space-between', marginTop:'30px'}}>
							<div style={{width:'170px', height:'33px'}}>
								<button className="btnInverse" onClick={() => setShowResultsDateModal(false)}>Cancel</button>
							</div>
							<div style={{width:'170px', height:'33px'}}>
								<button className="btn" onClick={exportPresentationResults}>Export</button>
							</div>
						</div>
					</div>
				</div>
			</section>
			</>
		}
		<div className="page" id="homePage">
			<div style={{height:'70px', width:'1120px', marginBottom:'50px'}}></div>
			<br></br>
			<div className="snackbarNormal" id="removeStu">Successfully removed student from {classDisplay}</div>
			<div className="snackbarRed" id="wentWrong">Something went wrong. Please try again or contact us for help.</div>
			<div className="snackbarRed" id="wentWrongPINSend">Something went wrong when sending PIN for login. Try again. If the problem persists, contact us for support</div>
			<div className="snackbarRed" id="wentWrongCommand">Something went wrong when attempting to send command. Try again</div>
			<div className="snackbarRed" id="wentWrongPIN">Something went wrong when attempting to save PIN. Try again</div>
			<div className="snackbarNormal" id="starting">Starting...Please be patient, this may take a minute</div>
			<div className="snackbarNormal" id="rebooting">Rebooting...Please be patient, this may take a minute</div>
			<div className="snackbarRed" id="noType">Unable to determine class type. Please refresh</div>
			<div className="snackbarYellow" id="noSelectStu">Students are not selected</div>
			<div className="snackbarYellow" id="noSelectPres">Narration is not selected. Select a narration first and then start a narration.</div>
			<div className="snackbarYellow" id="noSelectProj">Project is not selected. Select a project first and then launch a project.</div>
			<div className="snackbarYellow" id="noSelectMac">No machines are selected</div>
			<div className="snackbarYellow" id="msgEmpty">The message field is empty. Enter message to send to selected student(s)</div>
			<div className="snackbarYellow" id="noMultCode">Enter a multiplayer code</div>
			<div className="snackbarNormal" id="cmdSent">Command sent!</div>
			<div className="snackbarYellow" id="prohibitedChars">Type the machine nickname using the following characters: a-z, A-Z, 0-9, -, _, (, ), and space</div>
			<div className="snackbarYellow" id="instancesNotReady">One or more users selected are not ready to receive commands. Wait until their statuses are Ready or Connected and try again</div>
			<div className="snackbarYellow" id="lengthCap">The machine nickname must not exceed 15 characters in length</div>
			<div className="snackbarRed" id="unsupported">This action is not supported at this time</div>
			<div className="snackbarYellow" id="noClassSelected">No class selected</div>
			<div className="snackbarYellow" id="fileUploadWrong">Ensure you have selected a PNG file to send</div>
			<div className="snackbarYellow" id="imgTooLarge">The PNG you have selected is too big</div>
			<div className="snackbarRed" id="wentWrongAvatar">Ensure you have entered the Avatar URL from https://syglass.readyplayer.me/</div>
			<div className="snackbarRed" id="dupeCmdLimit">A max of 5 non-duplicate commands will be sent. Wait 10 seconds and then try again</div>
			<div className="snackbarYellow" id="alphaChars">The multiplayer code should contain only letters A-Z and numbers 0-9</div>
			<div className="snackbarYellow" id="msgSupportedChars">Include only the following supported characters in your message: a-z, A-Z, 0-9, !, ?, ., -, _, (, ), ', ", :, ;, #, and spaces.</div>
			<div className="snackbarNormal" id="renameSuccess">Machine has been successfully renamed</div>
			<div className="snackbarYellow" id="resultsFailedNone">Failed to generate aggregated results because none were found</div>
			<div className="snackbarRed" id="resultsFailed">Failed to generate aggregated results</div>
			<div className="snackbarYellow" id="resultsInvalidRange">The start date must be on or before the end date</div>
			<div className="snackbarNormal" id="resultsSucceeded">Successfully downloaded presentation results</div>

			<p style={((userType === "Teacher" || userType === "Scientist") && classList.length === 0) ? {fontSize:'14px', textAlign:'left', width:'1120px', wordBreak:'break-word', lineHeight:'1.75'} : {display:'none'}}>To get started, go to the "Classes" page and create a new class. After the class is created, a class PIN will be generated. Share this code with your students.
			Once a student enters the Class PIN on their Dashboard, the student information will appear below</p>

			<div className="dashboard" id="dashboard">
				<div style={userType !== "Scientist" ? {display: 'none'} : (creditsRemaining <= 0 ? {display: 'block'} : {display:'none'})}>
					<p className="noCreditsMessage"><b>There are currently no credits associated with your account. To purchase more, contact us at info@syglass.io.</b></p>
				</div>

				<div style={userType === "Teacher" || userType === "Scientist" ? {display:'flex', alignItems:'flex-start', marginBottom:'5px', marginTop:'30px'} : {display:'none'}}>
					<select id="classesDropdown" onChange={(e) => {setClassDisplay(e.target.value); getClassInfo(e.target.value, e.target[e.target.selectedIndex].className); setFirstClassLoad(true);}} defaultValue={'DEFAULT'}>
						<option key="Select" value="DEFAULT" disabled>Select Class</option>
						{classesList}
					</select>
					<div style={{display:'inline'}}>
						<div className="loader hidden homeLoader"></div>
					</div>
				</div>

				<div className="tableDiv" style={userType === "Teacher" || userType === "Scientist" ? {width: '1120px', height: '794px', overflowY: 'scroll', marginBottom:'13px', borderRadius:'5px', border:'0.5px solid #AFAFAF'} : {display:'none'}}>
					<table className="tableStuList">
						{classType === "Hardware" ? 
							<tr className="tableHeader headers">
								<th className="checkboxCol" style={{textAlign:'center'}}><input type="checkbox" checked={selectAllChecked} onChange={handleSelectAll} id="allCheckbox"></input></th>
								<th className="nameCol">Machine Name</th>
								<th className="sygStatCol">syGlass Status</th>
								<th className="presStatCol">Narration Status</th>
								<th className="narrationInfoCol">Narration</th>
								<th className="projectCol">Project</th>
								<th className="userCol">User</th>
							</tr>
							:
							<tr className="tableHeader headers">
								<th className="checkboxCol" style={{textAlign:'center'}}><input type="checkbox" checked={selectAllChecked} onChange={handleSelectAll} id="allCheckbox"></input></th>
								<th className="nameCol">User Name</th>
								<th className="emailCol">Email Address</th>
								<th className="sygStatCol">syGlass Status</th>
								<th className="presStatCol">Narration Status</th>
								<th className="narrationInfoCol">Narration</th>
								<th className="projectCol">Project</th>
							</tr>
						}
						<tr style={{height:'10px', background:'transparent'}}></tr>
						{classTable}
					</table>
				</div>
				<div style={userType === "Teacher" || userType === "Scientist" ? {display:'flex', justifyContent:'left'} : {display:'none'}}>
					<div style={classType === "Cloud" ? {width:'154px', height:'33px', display:'inline-block', marginRight:'10px'} : {display:'none'}}>
						<button className="btn" onClick={handleStart}>Start syGlass</button>
					</div>
					<div style={classType === "Cloud" ? {width:'154px', height:'33px', display:'inline-block', marginRight:'10px'} : {display:'none'}}>
						<button className="btnInverse" onClick={handleReboot}>Reboot syGlass</button>
					</div>
					<div style={classType !== "" ? {width:'120px', height:'33px', display:'inline-block', marginRight:'10px', marginLeftL:'174px'} : {display:'none'}}>
						<button className={classType === "Cloud" ? "btnInverse" : (classType === "Hardware" ? "btn" : "")} onClick={handleRemoveUserFromClass}>Unenroll</button>
					</div>
					<div style={classType.length === 0 ? {display:'none'} : {width:'214px', height:'33px', display:'inline-block'}}>
						<button className="btnInverse" onClick={leaveMultiplayer}>Remove from multiplayer</button>
					</div>
				</div>
				
				<div style={userType === "Teacher" || userType === "Scientist" ? {display:'flex', justifyContent:'space-between', marginTop:'31px', marginBottom:'0px'} : {display:'none'}}>
					<div style={{width:'544px', height:'375px'}}>
						<div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginTop:'3px', marginBottom:'10px'}}>
							<p style={{margin:'0px', fontSize:'14px', textAlign:'left', whiteSpace:'nowrap'}}>Choose a narration to display for the selected students</p>
							<div style={{width:'160px', position:'relative'}}>
								<input type="text" className="listSearchBar" placeholder="Search narrations" value={presentationSearch} onChange={(e) => setPresentationSearch(e.target.value)}></input>
								{presentationSearch.length > 0 &&
									<button type="button" className="listSearchClear" aria-label="Clear narration search" onClick={() => setPresentationSearch('')}>
										<span className="material-symbols-outlined" style={{fontSize:'16px'}}>close</span>
									</button>
								}
							</div>
						</div>
						<div className="secBackground" style={{width:'544px', height:'290px', marginBottom:'13px', borderRadius:'5px', border:'0.5px solid #AFAFAF'}}>
							<div style={{display:'flex', width:'534px', height:'290px', overflowY:'scroll', justifyContent:'left', flexDirection:'column', paddingLeft:'10px'}}>
								<p style={presentations.length === 0 ? {display:'block', fontSize:'14px', textAlign:'left'} : {display:'none'}}>Narrations will be displayed here</p>
								<p style={presentations.length > 0 && presentationOptionsRadio?.length === 0 ? {display:'block', fontSize:'14px', textAlign:'left'} : {display:'none'}}>No narrations match your search</p>
								{presentationOptionsRadio}
							</div>
						</div>
						<div style={{display:'flex', justifyContent:'left'}}>
							<div style={{width:'170px', height:'33px', display:'inline-block', marginRight:'10px'}}>
								<button className="btn" onClick={startPresentation}>Start narration</button>
							</div>
							<div style={{width:'170px', height:'33px', display:'inline-block', marginRight:'10px'}}>
								<button className="btnInverse" onClick={stopPresentation}>Stop narration</button>
							</div>
							<div style={{width:'170px', height:'33px', display:'inline-block'}}>
								<button className="btnInverse" onClick={openResultsDateModal}>Export Results</button>
							</div>
						</div>
					</div>
					<div style={{width:'544px', height:'375px'}}>
						<p style={{marginBottom:'10px', fontSize:'14px', textAlign:'left'}}>Send message to students</p>
						<div style={{marginBottom:'13px', height:'290px', width:'544px'}}>
							<form id="hudMessageForm" sty={{width:'544px', height:'290px'}}>
								<textarea id="hudMessageTextarea" style={{width:'523px', height:'280px', paddingLeft:'10px', paddingTop:'10px', paddingRight:'10px'}} maxLength="240" onChange={(event) => setHUDMessage(event.target.value)} placeholder={'You can send messages to students when they are in VR'}></textarea>
							</form>
						</div>
						<div style={{display:'flex', justifyContent:'left'}}>
							<div style={{width:'164px', height:'33px', display:'inline-block', marginRight:'10px'}}>
								<button className="btn" onClick={handleDisplayHUDMessage}>Send message</button>
							</div>
							<div style={{width:'164px', height:'33px', display:'inline-block'}}>
								<button className="btnInverse" onClick={shootConfetti}>Shoot confetti</button>
							</div>
						</div>
					</div>
				</div>
				<div style={userType === "Teacher" || userType === "Scientist" ? {display:'flex', justifyContent:'space-between', marginTop:'31px', marginBottom:'0px'} : {display:'none'}}>
					<div style={{width:'544px', height:'375px', marginTop:'40px'}}>
						<div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginTop:'3px', marginBottom:'10px'}}>
							<p style={{margin:'0px', fontSize:'14px', textAlign:'left', whiteSpace:'nowrap'}}>Choose a project to launch for the selected students</p>
							<div style={{width:'160px', position:'relative'}}>
								<input type="text" className="listSearchBar" placeholder="Search projects" value={projectSearch} onChange={(e) => setProjectSearch(e.target.value)}></input>
								{projectSearch.length > 0 &&
									<button type="button" className="listSearchClear" aria-label="Clear project search" onClick={() => setProjectSearch('')}>
										<span className="material-symbols-outlined" style={{fontSize:'16px'}}>close</span>
									</button>
								}
							</div>
						</div>
						<div className="secBackground" style={{width:'544px', height:'290px', marginBottom:'13px', borderRadius:'5px', border:'0.5px solid #AFAFAF'}}>
							<div style={{display:'flex', width:'534px', height:'290px', overflowY:'scroll', justifyContent:'left', flexDirection:'column', paddingLeft:'10px'}}>
								<p style={projects.length === 0 ? {display:'block', fontSize:'14px', textAlign:'left'} : {display:'none'}}>Projects will be displayed here</p>
								<p style={projects.length > 0 && projectsOptionsRadio?.length === 0 ? {display:'block', fontSize:'14px', textAlign:'left'} : {display:'none'}}>No projects match your search</p>
								{projectsOptionsRadio}
							</div>
						</div>
						<div style={{display:'flex', justifyContent:'left'}}>
							<div style={{width:'186px', height:'33px', display:'inline-block', marginRight:'10px'}}>
								<button className="btn" onClick={launchProject}>Launch project</button>
							</div>
						</div>
					</div>
					<div style={{width:'544px', height:'375px', marginTop:'40px'}}>
						<p style={{marginBottom:'10px', fontSize:'14px', textAlign:'left'}}>Choose a slide to display for the selected students</p>
						<div className="fSelectorBackground" style={{display:'flex', justifyContent:'left', maxWidth:'544px', borderRadius:'5px', border:'0.5px solid #AFAFAF', padding:'5px'}}>
							<input style={{width:'544px'}} type="file" accept="image/png" id="imageInput"></input>
						</div>
						<div style={{display:'flex', justifyContent:'left', marginTop:'13px'}}>
							<div style={{width:'186px', height:'33px', display:'inline-block', marginRight:'10px'}}>
								<button className="btn" onClick={() => {uploadSlide(document.getElementById("imageInput"))}}>Set slide</button>
							</div>
						</div>
					</div>
				</div>

				<div style={userType === "Teacher" || userType === "Scientist" ? {marginTop:'71px', display:'flex', justifyContent:'left'} : {display:'none'}}>
					<div style={{marginBottom:'0px'}}>
						<p style={{fontSize:'14px', textAlign:'left', marginBottom:'10px'}}>Multiplayer code</p>
						<div style={{width:'122px', height:'33px', display:'inline-block'}}>
							<input style={{marginTop:'0px', height:'33px'}} type="text" onChange={(e) => setMultiplayerCode(e.target.value)} placeholder="Enter code"></input>
						</div>
						<div style={{width:'164px', height:'33px', display:'inline-block', marginRight:'10px', marginLeft:'10px'}}>
							<button className="btn" onClick={joinMultiplayer}>Add students</button>
						</div>
					</div>
				</div>

				<hr style={userType === "Scientist" ? {display:'block', marginTop:'75px'} : {display:'none'}}></hr>
				<p style={userType === "Student" || userType === "Scientist" ? {fontSize:'16px', textAlign:'left', width:'1120px', wordBreak:'break-word', marginTop:'30px'} : {display:'none'}}>Generate a PIN to login to syGlass Cloud</p>
				<p style={userType === "Student" || userType === "Scientist" ? {fontSize:'14px', textAlign:'left', width:'1120px', wordBreak:'break-word'} : {display:'none'}}>After you have enrolled in a class via the "Classes" tab, you can generate a PIN to use when logging into syGlass Cloud</p>
				<div style={(userType === "Student" || userType === "Scientist") ? {display:'flex', alignItems:'flex-start', marginBottom:'125px', flexDirection:'column'} : {display:'none'}}>
					<div style={{display:'inline'}}>
						<select id="enrDropdown" onChange={(e) => {setClassToEnter(e.target.value); setShowEnterBtn(true);}} defaultValue={'DEFAULT'}>
							<option key="Select" value="DEFAULT" disabled>Select Class to Enter</option>
							{enrollList}
						</select>
						<div style={showEnterBtn === true ? {width:'140px', height:'33px', display:'inline-block', marginLeft:'16px', marginTop:'10px'} : {display:'none'}}>
							<button className="btn" onClick={(e) => handleGenPIN(e)}>Generate PIN</button>
						</div>
					</div>

					<div id="studentPIN" style={stuPIN.length !== 0 ? {display:'inline-block', marginTop:'40px'} : {display:'none'}}>
						<br></br>
						<p style={{fontSize:'18px'}}>{stuPIN.substring(0,2)} {stuPIN.substring(2,4)}</p>
						<p>This PIN is active for the next hour</p>
					</div>
				</div>
				<hr></hr>

				<div style={{marginTop:'30px', justifyContent:'left'}}>
					<p style={{fontSize:'16px', textAlign:'left'}}>Create Avatar</p>
					<p style={{fontSize:'14px', textAlign:'left'}}>Press the button below to create an avatar that will be used in VR.</p>
					<div style={{width:'164px', height:'33px'}}>
						<button className="btn" onClick={() => navigate("/create-avatar")}>Create Avatar</button>
					</div>
				</div>
				
				{/* <div style={userType === "Scientist" ? {display:'block'} : {display:'none'}} className="creditsDisplay"><b>
					Credits
					<br></br>
					Remaining:
					<div className={handleCreditsDisplay()}>
						<p style={{'color': 'white', 'margin':'0'}}>{creditsRemaining}</p>
					</div>
				</b></div> */}

			</div>
			<br></br>
		</div>
		</>
	);

}

export default HomePage;
